// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DriverKillQuestions_buttons__2mbOB","questionContainer":"DriverKillQuestions_questionContainer__20C-B"};